<div class="mt-1">
  <p-selectButton
    [options]="calViews"
    (onChange)="calViewChanged($event)"
    [(ngModel)]="selCalView"
    optionLabel="label"
    optionValue="value"></p-selectButton>
</div>
<div class="mt-1">
  <full-calendar #calendar [options]="calendarOptions" [deepChangeDetection]="true"></full-calendar>
</div>

<p-popover #op [dismissable]="true" appendTo="body">
  <div *ngIf="popupRequest !== null && popupRequest !== undefined">
    <div><strong>Order Item Type:</strong> {{ popupRequest.ItemType }}</div>
    <div><strong>Container Name:</strong> {{ popupRequest.ContainerName }}</div>
    <div><strong>Delivery Location:</strong> {{ popupRequest.DeliveryLocationName }}</div>
    <div><strong>Order Item Desc:</strong> {{ popupRequest[itemDescName] }}</div>
    <div><strong>Order Item Instance Id:</strong> {{ popupRequest.InstanceSequence }}</div>
    <div><strong>Status:</strong> {{ popupRequest.InstanceStatus }}</div>
    <div style="white-space: pre-wrap"><strong>Note:</strong> {{ popupRequest.InstanceNote }}</div>
  </div>
</p-popover>
